<timepicker [(ngModel)]="timeInput"
            [ngModelOptions]="{standalone: true}"
            (click)="detectChanges()"
            (blur)="customPropagateTouch()"
            [disabled]="isDisabled"
            [minuteStep]=1
            #timepicker>
</timepicker>
